import { z } from 'zod'

export type TranslationKey = string

const interpolationValueSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('dynamicValue'),
    path: z.string(),
  }),
  z.object({
    type: z.literal('staticValue'),
    value: z.string(),
  }),
])

const interpolationValuesSchema = z.record(interpolationValueSchema)

const nonTranslatableTextSchema = z.object({
  type: z.literal('nonTranslatableText'),
  text: z.string(),
  values: interpolationValuesSchema.optional(),
})

const translatableTextSchema = z.object({
  type: z.literal('translatableText'),
  translationKey: z.string(),
  values: interpolationValuesSchema.optional(),
})

const translatableTextWithDynamicKeySchema = z.object({
  type: z.literal('translatableTextWithDynamicKey'),
  getTranslationKey: z.function().args(z.record(z.unknown())).returns(z.string()),
  values: interpolationValuesSchema.optional(),
})

const nonTranslatableTextFromObjectSchema = z.object({
  type: z.literal('nonTranslatableTextFromObject'),
  path: z.string(),
  values: interpolationValuesSchema.optional(),
})

export const textContentSchema = z.discriminatedUnion('type', [
  nonTranslatableTextSchema,
  translatableTextSchema,
  translatableTextWithDynamicKeySchema,
  nonTranslatableTextFromObjectSchema,
])

export type InterpolationValue = z.infer<typeof interpolationValueSchema>

export type InterpolationValues = z.infer<typeof interpolationValuesSchema>

export type TextContent = z.infer<typeof textContentSchema>
